const faqs = [
  {
    q: '大师兄影视需要付费吗？',
    a: '完全免费！大师兄影视始终坚持免费观影的初心，所有影视内容均可免费在线观看，无需充值会员，也不存在任何隐形收费。我们通过技术优化和高效运营来维持平台运转，让每一位用户都能零门槛享受高清观影体验。',
  },
  {
    q: '播放视频时出现卡顿怎么办？',
    a: '我们提供多种画质选项（流畅/高清/超清/4K），您可以根据当前网络状况手动切换合适的清晰度。同时建议关闭其他占用带宽的应用，或尝试切换WiFi/移动网络。如仍有问题，可通过页面底部的联系方式向我们反馈，技术团队会在24小时内排查优化。',
  },
  {
    q: '支持哪些设备观看？可以投屏到电视吗？',
    a: '大师兄影视全面兼容手机、平板、电脑和智能电视。我们提供iOS和Android客户端下载，同时也支持网页端直接观看。投屏功能已内置在播放器中，点击播放器右上角的投屏按钮，选择您的电视设备即可将内容投射到大屏幕观看，支持DLNA和AirPlay协议。',
  },
  {
    q: '影片更新频率如何？能看到最新上映的电影吗？',
    a: '我们保持每日更新的节奏，热播剧集通常在电视台播出后2小时内上线，院线电影在下映后30天内上线高清版本。您可以在「最新动态」模块查看每日更新详情。此外，我们还设有追剧日历功能，订阅您关注的影片后会及时收到更新提醒。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600">关于大师兄影视，你可能想了解的一些事情。</p>
        </div>

        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-bold font-heading text-foreground-950 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}